export const followersData = {
    data() {
        return {
            followersList: [
                {
                    order: 1,
                    name: "امین سنجرموسوی",
                    userName: "SanjarMoosavi",
                    avatar: "https://mdbcdn.b-cdn.net/img/new/avatars/8.webp",
                    chatLink: "849220",
                    witrinoLink: "164844",
                },
                {
                    order: 2,
                    name: "محمد کریمی",
                    userName: "M.Karimi",
                    avatar: "https://mdbcdn.b-cdn.net/img/new/avatars/2.webp",
                    chatLink: "",
                    witrinoLink: "",
                },
                {
                    order: 3,
                    name: "جواد معلمی",
                    userName: "javad",
                    avatar: "https://mdbcdn.b-cdn.net/img/new/avatars/3.webp",
                    chatLink: "54680",
                    witrinoLink: "",
                }
            ]
        }
    },
    methods: {
        getSummary() {
            return this.followersList.slice(0, 3);
        },
        getLength() {
            return this.followersList.length;
        }
    }
}